import { Link } from "react-router-dom";
import { useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Menu, X } from "lucide-react";
import { Button } from "./Button";

export default function Navigation() {
  const [open, setOpen] = useState(false);

  const links = [
    // { name: "How It Works", href: "#howitworks" },
    // { name: "Features", href: "#features" },
    // { name: "Pricing", href: "#pricing" },
    // { name: "FAQ", href: "#faq" },
  ];

  return (
    <motion.nav
      className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md border-b border-gray-100 z-50"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-6xl mx-auto flex justify-between items-center px-6 py-3">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-2xl flex items-center justify-center bg-blue-50 text-blue-700">
            <ShieldCheck size={24} />
          </div>

          <h1 className="font-heading text-2xl font-bold tracking-tight text-gray-900">
            RevUShield
          </h1>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-3">
          {links.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="
        font-heading
        text-gray-600
        hover:text-gray-900
        transition-colors
        duration-200
      "
            >
              {link.name}
            </a>
          ))}

          <Link to="/login">
            <Button
              variant="secondary"
              className="
              text-gray-800
              hover:bg-blue-600
              hover:text-white
              border
              border-gray-200
              rounded-xl
              px-5
              py-2
              shadow-sm
            "
            >
              Login
            </Button>
          </Link>

          <Link to="/register">
            <Button className="px-5 py-2 rounded-xl shadow-md">
              Start Free Trial
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="
            md:hidden
            h-10
            w-10
            rounded-xl
            border
            border-gray-200
            bg-gray-100
            flex
            items-center
            justify-center
            text-gray-700
          "
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <motion.div
          className="md:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-3 shadow-xl"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25 }}
        >
          {links.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="
                font-heading
                block
                text-gray-700
                hover:text-white
                bg-gray-100
                hover:bg-blue-600
                border border-gray-200
                hover:border-blue-600
                px-4 py-3
                rounded-xl
                transition-all
                duration-200
                shadow-sm
              "
              onClick={() => setOpen(false)}
            >
              {link.name}
            </a>
          ))}

          <div className="grid gap-3 pt-2">
            <Link to="/login" onClick={() => setOpen(false)}>
              <Button
                variant="secondary"
                className="
                w-full
                text-gray-800
                hover:bg-blue-600
                hover:text-white
                border
                border-gray-200
                rounded-xl
              "
              >
                Login
              </Button>
            </Link>

            <Link to="/register" onClick={() => setOpen(false)}>
              <Button className="w-full rounded-xl shadow-md">
                Get Started
              </Button>
            </Link>
          </div>
        </motion.div>
      )}
    </motion.nav>
  );
}
